import { FinancialsPerformanceMetricsColumn } from 'common/types/financials';
import { Row } from 'common/types/scalarSpreadsheet';
import { ICell, IScalarSpreadsheetConfig } from 'models/interfaces/spreadsheet-types/core-types';
import { Change } from 'utilities/sanitizeCellValue/sanitizeCellValue';
import getOutdatedCellsChanges from './getOutdatedCellsChanges';

const columnUpdateActionCallback = ({ cell, scope, onCellsChanged, reverseParser }: {
  cell: ICell,
  scope: string,
  onCellsChanged: (changes: Change<ICell>[], scope: string) => void,
  reverseParser?: (sheet: IScalarSpreadsheetConfig) => FinancialsPerformanceMetricsColumn[],
}) => {
  const { sheet } = cell;
  const changes = getOutdatedCellsChanges({
    cell,
    rowConfig: sheet?.rowConfig as Row[],
    cells: sheet?.cells as Record<string, ICell<object>>,
  });
  onCellsChanged(changes, scope);

  const columnsToSet = reverseParser ? reverseParser(sheet!) : [...sheet!.columns];
  const updatedColumn = columnsToSet[cell.columnIndex as number];
  updatedColumn.needs_actualization = false;
  sheet!.reset({ columns: columnsToSet });
  document.dispatchEvent(new Event('columnUpdated'));
};

export default columnUpdateActionCallback;
